export enum Cookie {
  Language = 'bucp-language',
  CookiePreferencesSaved = 'cookies-preferences-saved',
  CookiePreferences = 'cookies-preferences',
}

export interface CookiePreferences {
  googleAnalyticsEnabled: boolean;
}
